import type {
  GetDocumentRequestType,
  GetDocumentResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const getDocument = async (params: GetDocumentRequestType) => {
  const url = `/api/v2/documents/${params.documentId}`;
  const response = await apiAuthClient.get<GetDocumentResponseType>(url);

  return response.data.data;
};
